/// <reference path="../../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var Directives;
    (function (Directives) {
        var ApPageNavbarController = /** @class */ (function () {
            function ApPageNavbarController($scope, $route, $routeParams, applicationService, authenticationService, locationService, $location) {
                var _this = this;
                this.$scope = $scope;
                this.$route = $route;
                this.$routeParams = $routeParams;
                this.applicationService = applicationService;
                this.authenticationService = authenticationService;
                this.locationService = locationService;
                this.$location = $location;
                this.isRedCap = false;
                this.$scope.$on(ap.Constants.eventNames.angular.routeChangeSuccess, function () {
                    _this.init($route.current.name);
                });
                this.isRedCap = this.$location.search().thirdparty === ThirdParty.RedCap;
                this.init($route.current.name);
            }
            ApPageNavbarController.prototype.init = function (routeName) {
                this.activeTab = routeName;
            };
            ApPageNavbarController.prototype.clearParams = function () {
                // WP is clearing their params on purpose, but for MP2 Reporting we don't want this
                if (this.authenticationService.authorizationData.LoginSystem !== 'SSO') {
                    this.applicationService.reportParameters = {};
                }
            };
            ApPageNavbarController.prototype.redirectToReports = function () {
                this.clearParams();
                var rp = this.$routeParams;
                if (!ap.Utilities.isNullOrUndefined(rp) && !ap.Utilities.isNullOrUndefined(rp.organizationCacheKey) && rp.organizationCacheKey !== ':organizationKey?') {
                    this.locationService.redirect(ap.Constants.routes.reporting, null, rp.organizationCacheKey);
                }
                else {
                    this.locationService.redirect(ap.Constants.routes.reporting, null, null);
                }
            };
            ApPageNavbarController.prototype.setActiveTab = function (tabName) {
                this.activeTab = tabName;
            };
            ApPageNavbarController.$inject = [
                '$scope',
                '$route',
                '$routeParams',
                'applicationService',
                'authenticationService',
                'locationService',
                '$location'
            ];
            return ApPageNavbarController;
        }());
        Directives.ApPageNavbarController = ApPageNavbarController;
        angular
            .module('app.Directives')
            .controller('ApPageNavbarController', ApPageNavbarController);
    })(Directives = app.Directives || (app.Directives = {}));
})(app || (app = {}));
